// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const OpenHiggsfieldApp = registerClientReference(
    function() { throw new Error("Attempted to call OpenHiggsfieldApp() from the server but OpenHiggsfieldApp is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/openhiggsfield/openhiggsfield-app.tsx",
    "OpenHiggsfieldApp",
);
